import { render, staticRenderFns } from "./UnitOfMeasuresRegistryNewForm.vue?vue&type=template&id=3bfc8bb1"
import script from "./UnitOfMeasuresRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasuresRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports